// TODO: move all endpoints related to grades from ../lms.js into this file
import { getGBUrl } from '../../utils/config';

async function batchSaveGrades({ courseId, grades }) {
  try {
    const gradebookV1Url = `${getGBUrl()}/api/v1`;
    const response = await fetch(
      `${gradebookV1Url}/courses/${courseId}/gradebook/override/grades/batch`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Pragma: 'no-cache',
        },
        body: JSON.stringify({ grades }),
      },
    );

    const data = await response.json();

    if (!response.ok) {
      throw data;
    }

    return Promise.resolve(data);
  } catch (error) {
    return Promise.reject(error);
  }
}

export default {
  batchSaveGrades,
};
